import React from 'react';
import PropTypes from 'prop-types';
import {
  // PageHeader,
  Button,
  Row,
  Col,
  Icon,
  Typography
} from 'antd';

import moment from 'moment';

const { Title } = Typography;
const { Paragraph } = Typography;


export default class ChatHeader extends React.Component {
  static propTypes = {
    conversation: PropTypes.object,
    onCall: PropTypes.bool,
    setActive: PropTypes.func,
    endCall: PropTypes.func,
    archiveConversation: PropTypes.func,
  }

  clearConversation = () => {
    this.props.setActive(null);
  }

  render() {
    const { conversation } = this.props;
    if (!conversation) return null;

    return (
        <Row style={{backgroundColor : '#fff', paddingTop:'36px', paddingBottom:'36px'}}>
          <Col span={20} offset={2}>
            <Title level={2}>{conversation.name.replace(/\b\w/g, l => l.toUpperCase())}</Title>
            <div style={{display:'flex', flexDirection:'row', justifyContent:'space-between', alignItems:'flex-end'}}>
              <Paragraph>{moment(conversation.created_at).fromNow()} | {conversation.url || "No url found"}</Paragraph>
              <div>{this._renderCallActionButtons()}</div>
            </div>
            
          </Col>
        </Row>
    );
  }

  _renderCallActionButtons = () => {

    const endCallButton = this.props.onCall && (
      <Button key="3" type="danger" onClick={this.props.endCall}>
        <Icon type="phone" theme="filled" />End Call
      </Button>
    );

    return [
      endCallButton,
    ];
  }
}
